import React, { memo } from "react";
import GlobalVideoGeneratorPreview from "../../../SelfServiceCampaignCreation/Previews/VideoGenerator/GlobalVideoGeneratorPreview/GlobalVideoGeneratorPreview";
import { forceHttps } from "../../../../utils/Helpers";

const VideoImagePreview = ({
  isTemplateVideo,
  dimensionsPreview,
  templateInputProps,
  autoCroppingImage,
  orientationSelected,
  videoDuration,
  TemplateComponent
}) => {
  const { logo, video } = templateInputProps;

  return isTemplateVideo ? (
    <GlobalVideoGeneratorPreview
      key={`video-generator-preview-${autoCroppingImage}`}
      remotionTemplate={TemplateComponent}
      width={parseInt(dimensionsPreview?.width)}
      height={parseInt(dimensionsPreview?.height)}
      videoData={{
        ...templateInputProps,
        logo: logo ? forceHttps(logo) : null,
        video: video ? forceHttps(video) : null,
        backgroundImage: forceHttps(autoCroppingImage),
        width: parseInt(dimensionsPreview?.width),
        height: parseInt(dimensionsPreview?.height),
        orientation: orientationSelected,
        duration: videoDuration
      }}
      isAssistant
    />
  ) : (
    <TemplateComponent
      key={`image-preview-${autoCroppingImage}`}
      {...templateInputProps}
      logo={logo ? forceHttps(logo) : null}
      backgroundImage={forceHttps(autoCroppingImage)}
      width={dimensionsPreview?.width}
      orientation={orientationSelected}
      isNewCampaign
    />
  );
};

export default memo(VideoImagePreview);
